export default {
    top_menu: [
        {name:'Основното нещо',    id:0},
        {name:'Шоу бизнес', id:1},
        {name:'Готвене',  id:2},
        {name:'Политика',   id:3},
        {name:'+18',  id:4},
        {name:'Общество',   id:5},
        {name:'Здраве',   id:6},
    ],
    read_other: 'Прочетете още',
    read_more:  'Повече информация',
    not_found:  'Ничего не найдено',
    read_also:  'Прочетете също',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Всички права запазени.',
    subscribe: 'Абонирайте се за',

    thank_order: 'БЛАГОДАРЯ ЗА ПОРЪЧКАТА',
    specialist_contact: 'Нашият специалист ще се свърже с вас скоро, изчакайте нашето обаждане.',
    attention: 'Отстъпки от партньори:',
    hurry: 'Побързайте, времето за активиране на отстъпката е ограничено! Имате само <span id="time" class="time">30:00</span> минути, за да изберете един от тези уникални продукти:',

    hour_ago1: "Преди час",
    hour_ago2: "преди часове",
    hour_ago3: "преди часове",
    new_publications: "Нови публикации",
    read: "Прочети",
    today_at: "Днес в",
    author_names: ['НИНА ДОБРЕВ','ХРИСТ МИШКОВ','ЛИЛИ ИВАНОВА'],
    main_news: "Основни новини",
    leave_already: "Напускате ли вече? Изчакайте, актуализирахме новините за вас",
    already_shared: "вече споделено"

}